export default __webpack_public_path__ + "static/media/arrow-fat-down-black.e16ea6d0.svg";